var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.selectableCount)?_c('binds-table-head',{staticClass:"binds-table-cell-selection"},[_c('div',{staticClass:"binds-table-cell-container"},[_c('binds-checkbox',{attrs:{"model":_vm.allSelected,"disabled":_vm.isDisabled},on:{"change":_vm.onChange}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }